import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../_foundation/services/auth/auth.service';
import { Injectable } from '@angular/core';
import { SetupService } from '../setup/setup.service';
import { VesselService } from '../vessel/vessel.service';
import { PtLuxonDate } from '../../models/projects/date.models';
import { User } from '../../_foundation/models/security.models';
import { Observable } from 'rxjs/Rx';
import { MorningMinutesReportPreviewData } from '../../models/morning-minutes/morning-minutes.models';
import { AppConfig } from '../../app/app.config';
import { DateParserService } from '../daily-log/daily-log-time/date-parser-service';
import { DateTime } from 'luxon';

@Injectable()
export class MorningMinutesReportService {
  config = AppConfig.settings;

  constructor(
    private http: HttpClient,
    private setupService: SetupService,
    private vesselService: VesselService,
    private authService: AuthService,
    private dateParserService: DateParserService
  ) {

  }

  async getCurrentMomReportVersionNumber(date: PtLuxonDate): Promise<Observable<string>> {
    // convert to UTC before sending to API
    const dateWithSystemOffset = this.dateParserService.removeOffsetFromLuxonDate(date.dateTime);
    const dateLong = dateWithSystemOffset.toMillis();
    const url = `${this.config.apiUrl}api/morningminutesreport/getcurrentversionnumber/${dateLong}`;

    return this.http.get<string>(url);
  }

  getCurrentMomDownloadLink(date: PtLuxonDate): string {
    // convert to UTC before sending to API
    const dateWithSystemOffset = this.dateParserService.removeOffsetFromLuxonDate(date.dateTime);
    const dateLong = dateWithSystemOffset.toMillis();

    return `${this.config.apiUrl}api/morningminutesreport/getcurrentreport/${dateLong}`;
  }

  getPreviewReportDownloadLinkWithPendingChanges(
    date: DateTime,
    vesselId: number,
    isImplementer: boolean,
    reportPreviewAppData: MorningMinutesReportPreviewData): Observable<any> {
    // convert to UTC before sending to API
    const dateLong = date.toMillis();
    const user = this.authService.currentUser<User>();
    const url = `${this.config.apiUrl}api/morningminutesreport/${dateLong}/${vesselId}/${user.id}/${isImplementer}/true/generatenewreport`;

    return this.http.post(url, reportPreviewAppData, {
      responseType: 'blob',
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    });
  }

  getNewMomDownloadLink(date: PtLuxonDate, vesselId: number, isImplementer: boolean): string {
    // convert to UTC before sending to API
    const dateLong = date.dateTime.toMillis();

    return `${this.config.apiUrl}api/morningminutesreport/${dateLong}/${vesselId}/
    ${this.authService.currentUser<User>().id}/${isImplementer}/false/generatenewreport`;
  }

  // Checks if morning minutes needs to be re-generated or not
  public async checkDataModified(date: PtLuxonDate): Promise<Boolean> {
    // convert to UTC before sending to API
    const dateLong = date.dateTime.toMillis();
    const url = `${this.config.apiUrl}api/morningminutesreport/checkdatamodified/${dateLong}`;

    return this.http.get<boolean>(url).toPromise();
  }

  public async updateDataModifiedFlag(date: PtLuxonDate) {
    // convert to UTC before sending to API
    const dateLong = date.dateTime.toMillis();
    const url = `${this.config.apiUrl}api/morningminutesreport/updatedatamodifiedflag/${dateLong}`;

    return this.http.get<boolean>(url).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/services/morning-minutes/morning-minutes-report.service.ts